export { Terms } from './Terms';
